import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { ServerIcon } from 'lucide-react'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const proxyDefinition: SmartSignalDefinition<{
  proxy?: IdEventV4['proxy']
  proxy_confidence?: IdEventV4['proxy_confidence']
  proxy_details?: IdEventV4['proxy_details']
}> = {
  key: 'proxy',
  label: 'Proxy',
  extract: (e) => ({
    proxy: e.proxy,
    proxy_confidence: e.proxy_confidence,
    proxy_details: e.proxy_details,
  }),
  icon(e) {
    const p = this.extract(e)?.proxy
    return (
      <ServerIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.proxy
    return p === true
  },
  isWeb: () => true,
  isMobile: () => true,
  searchFor: '"proxy":',
  documentationHash: '#ip-blocklist-matching',
  urlParamKey: IdentificationUrlKeys.ResidentialProxy,
}
